export default function Submit(props)
{
    const {
        className,
        disabled,
        id,
        name,
        onChange,
        required,
        value,
        working
    } = props;

    let colorStyles = "bg-cc text-white font-bold text-center no-underline rounded rounded-full py-20 min-w-[245px] focus:border-bb focus:ring-bb" + (!working ? " hover:bg-cc/60 group-hover:bg-cc/60 cursor-pointer" : "");

    if (disabled) {
        colorStyles = "inline-block bg-grey text-grey-2 font-bold text-center no-underline rounded rounded-full py-20 min-w-[245px]";
    }

    return (
        <input
            id={ id }
            name={ name }
            className={ colorStyles + (className ? " " + className : "") }
            type="submit"
            value={ value ?? ""}
            disabled={ disabled }
            required={ required }
            onChange={ onChange }
        />
    );
}